import { useMemo } from 'react';
import { useGetAppStatusConfig } from '~/config/firebase/remote-config';
import type { AppStatusConfig } from '~/core/components/incident-communication/models/AppStatusConfig';
import { defaultAppStatusConfig } from '~/core/components/incident-communication/models/AppStatusConfig';

export const useAppStatusConfig = (): AppStatusConfig => {
  const { data: raw } = useGetAppStatusConfig();
  return useMemo(() => {
    if (!raw) {
      return defaultAppStatusConfig;
    }
    try {
      const parsed = JSON.parse(raw) as Partial<AppStatusConfig>;
      const merged: AppStatusConfig = { ...defaultAppStatusConfig, ...parsed };
      if (merged.bannerSeverity !== 'WARNING') {
        merged.bannerSeverity = 'INFO';
      }
      return merged;
    } catch {
      return defaultAppStatusConfig;
    }
  }, [raw]);
};
